/* global G */
import { asyncPipeSpread, setKey } from 'lib/util'

/**
 * Sets the `model`s api type to `api` for all `hooks`.
 *
 * @param {string} api whether or not to set the api type to `serviceitem`
 * @returns {function(*): function(*): function(...[*]): Promise<*[]>}
 */
const withApi = api => hooks => obj => async (...args) => {
  const { api: currentApi } = obj[G.MODEL][G.PROPS]
  let newArgs

  try {
    setKey(api, 'api', obj[G.MODEL][G.PROPS])

    newArgs = hooks
      ? await asyncPipeSpread(...Object.keys(hooks).map(hook => hooks[hook](obj)))(...args)
      : args
  } finally {
    setKey(currentApi, 'api', obj[G.MODEL][G.PROPS])
  }

  return newArgs || args
}

export default withApi
